module.exports = __webpack_public_path__ + "img/pay.ccfa8ac7.png";